const buildRedirectUri = (value) => {
  if (value) {
    return value;
  }

  if (typeof window !== "undefined") {
    return window.location.origin;
  }

  return "";
};

const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AAD_CLIENT_ID || "",
    authority: `https://login.microsoftonline.com/${
      process.env.REACT_APP_AAD_TENANT_ID || ""
    }`,
    redirectUri: buildRedirectUri(process.env.REACT_APP_AAD_REDIRECT_URI),
    postLogoutRedirectUri: buildRedirectUri(
      process.env.REACT_APP_AAD_POST_LOGOUT_REDIRECT_URI
    ),
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

const microsoftAuthEnabled = Boolean(process.env.REACT_APP_AAD_CLIENT_ID);

const loginRequest = {
  scopes: (process.env.REACT_APP_PBI_SCOPES || "")
    .split(" ")
    .map((scope) => scope.trim())
    .filter(Boolean),
};

export { msalConfig, loginRequest, microsoftAuthEnabled };
